import { render, staticRenderFns } from "./movie-item.vue?vue&type=template&id=4e2d6c22&scoped=true&"
import script from "./movie-item.vue?vue&type=script&lang=js&"
export * from "./movie-item.vue?vue&type=script&lang=js&"
import style0 from "./movie-item.vue?vue&type=style&index=0&id=4e2d6c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d6c22",
  null
  
)

export default component.exports